
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getMarkChatReadDtoFormGroup() {
return new FormGroup({
    messageId: new FormControl<number | undefined>(undefined, [Validators.required, Validators.min(1)]),
})
;
}
      